module.exports = __webpack_public_path__ + "img/HusseinSharaf.ee4c3c1a.jpg";